<template>
    <div class="min-h-full flex flex-col gap-2">
        <div class="flex justify-start items-center gap-1 w-full">
            <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
            <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
            <p class="text-[18px] laptop:text-[20px] font-semibold font-roboto pl-2 m-0 text-[#333333]">Financing</p>
        </div>
        <div>
            <div class="w-full py-2">
                <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="financialInstitution">Financial
                    Institution<span class="ml-1 text-[#EE5851]">*</span></label>

                <customDropdown
v-model="selectedFinancialInstitutions" :items="financialInstitutes" label-key="title"
                    value-key="object" button-text="Select Financial Institution" :button-warpper-class="'relative w-full'"
                    :button-class="'!rounded-[8px] border border-[#E2E5EC] flex items-center justify-between px-[12px] !py-[4px] !h-[40px] w-full bg-white disabled:bg-[#F7F8FA]'"
                    :button-text-class="[
                        'font-roboto text-[14px]',
                        selectedFinancialInstitutions ? 'text-[#333]' : 'text-[#AAAAAA]'
                    ]" :button-icon-class="'hidden'"
                    :dropdown-list-class="'origin-top-right absolute right-0 mt-[6px] w-full rounded-[8px] border border-[#E2E5EC] z-20 bg-white shadow-[0px_4px_12px_0px_#0000001A] overflow-hidden'"
                    :dropdown-list-l-i-class="'hover:bg-[#F3F4F7]'"
                    :dropdown-list-anchor-class="'no-underline font-roboto block px-[12px] py-[10px] text-[13px] cursor-pointer text-[#333333] hover:bg-[#F3F4F7]'"
                    :disabled="financialInstitutes.length == 1" @select="onTypeSelect"
/>
            </div>

            <div
v-if="selectedFinancialInstitutions?.is_payment_link" ref="tab-4"
                class="min-h-full flex flex-col gap-3 mb-[3rem]"
>
                <div v-if="!linkGenerated" ref="tab-4" class="min-h-full gap-3 pt-[30px]">
                    <p class="text-[14px] font-roboto text-[#333] mb- text-justify tablet:text-center">
Click <span
                            class="font-bold"
>Generate Link</span> to
                        create your secure payment link. Once generated, the link will appear here and can be used to complete checkout using a credit/debit card or to apply for available Stripe financing options.
                    </p>
                    <button
class="fxBtnPrimary !mt-[20px] !mx-auto !flex"
                        @click="generateLinkClicked()"
>
Generate
                        Link
</button>
                </div>

                <div v-else>
                    <div class="w-full py-1">
                        <p class="text-[14px] font-normal font-roboto mb-[15px] text-[#333333]">
Use this
                            payment link to make an online payment. You can get financing through this
                            option.
</p>
                    </div>
                    <div
                        class="relative w-full h-[40px] rounded-[8px] !border !border-[#E2E5EC] bg-[#F7F8FA] overflow-hidden"
>
                        <input
type="text" :value="stripURL"
                            class="w-full h-full p-1.5 2xl:p-2.5 !border-0 outline-none !text-[14px] !rounded-[10px] largeDesktop:text-base !text-[#333333] "
                            disabled
>
                        <button
class="absolute top-0 right-0 h-full w-[40px] flex items-center justify-center bg-[#00B7C2]"
                            @click="copysharelink"
>
                            <img
src="../../assets/images/copy-icon.png" alt="Share Icon"
                                class="w-4 h-4 2xl:w-6 2xl:h-6"
>
                        </button>
                    </div>
</div>
            </div>

            <div
v-else-if="selectedFinancialInstitutions?.is_other"
                class="w-full py-2 grid grid-cols-1 tablet:grid-cols-3 gap-[15px]"
>
                <div class="col-span-1 tablet:col-span-2">
                    <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="financialInstitution">Enter
                        Financial
                        Institution Name</label>
                    <div v-if="selectedFinancialInstitutions.is_title_prefilled == '1'" class="m-0 text-[16px] min-h-[40px] font-roboto flex items-center p-[7px] rounded-[7.5px] select-none border-[1px] border-[#E2E5EC] bg-[#F7F8FA] text-[#666]">
                            {{ institute_name }}
                    </div>    
                    <inputComponent
v-else ref="instituteName" v-model="institute_name" name="financialInstitution"
                        required placeholder="Enter Financial Institution Name"
                        length="120" error-message="Invalid Financial Institution Name"
                        custom-class="!rounded-[8px] !text-[14px] border border-[#E2E5EC] outline-none !py-[7px] !px-[10px] w-full rounded-lg placeholder:text-[#AAAAAA] text-[#333333]"
/>
                </div>
                <div class="col-span-1">
                    <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="financialInstitution">
                        Dealer Fee</label>
                    <div class="w-full h-[40px] relative">
                        <span
                            class="absolute left-0 top-0 z-10 w-[40px] h-full rounded-l-[8px] flex justify-center items-center font-medium text-[15px] bg-[#7695FF] text-white"
>
                            %
                        </span>
                        <inputComponent
ref="dealerFee" v-model="dealerFee" name="dealerFee" :required="!$helper.isEmpty(dealerFee)" placeholder="0" length="6"
                            type="text" inputmode="decimal"
                            :regex="/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/" error-message="Invalid Dealer Fee"
                            custom-class="!rounded-[8px] !text-[14px] border border-[#E2E5EC] outline-none !pl-[50px] !py-[7px] pr-2.5 w-full rounded-lg placeholder:text-[#AAAAAA] text-[#333333]"
/>
                    </div>
                </div>
            </div>

            <div
v-else-if="selectedFinancialInstitutions?.is_plan_selectable"
                class="w-full py-3 flex justify-center items-center"
>
                <button
v-if="!selectedPlan" class="w-[130px] h-[40px] flex justify-center items-center font-roboto font-medium text-base rounded-full transition-all border-[1px] border-[#7695FF] text-[#fff] laptop:text-[#7695FF] bg-[#7695FF] laptop:bg-white laptop:hover:bg-[#7695FF] laptop:hover:text-white"
                    @click="selectPlanClicked"
>
                    Select Plan
                </button>
                <div v-else class="w-[100%]">
                    <div
                        class="rounded-[12px] pb-[30px] laptop:pb-2.5 p-[12px] border-1 border-[#E2E5EC] bg-[#F9FAFF] relative"
>
                        <div class="flex items-center justify-between py-2 border-b border-[#EFEFEF]">
                            <h4 class="mb-0 text-[15px] font-medium text-[#333333]" v-html="selectedPlan.description" />
                            <button
class="group focus:outline-none focus:!shadow-[0_0_5px_3px_#cccccc6b] min-w-[30px] min-h-[30px] rounded-full shadow-[0_0_5px_3px_#cccccc6b] flex justify-center items-center transition-all border border-[#F67280] laptop:border-[#EFEFEF] bg-[#F67280] laptop:bg-white laptop:hover:!bg-[#F67280]
                            laptop:relative mobile:absolute right-2.5 -bottom-[15px]" @click="selectedPlan = null"
>
                                <img
src="../../assets/images/trashIcon.png" class="w-[16px] h-[16px] object-contain filter mobile:invert laptop:invert-0 mobile:brightness-0 laptop:brightness-[unset] 
                                    laptop:group-hover:invert laptop:group-hover:brightness-0"
>
                            </button>
                        </div>
                        <div
                            class="grid laptop:gap-2 laptop:gap-y-2.5 grid-cols-1 laptop:grid-cols-4 mt-[10px] laptop:mt-[20px]"
>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]"
>
                                <p class="text-[14px] mb-0 text-[#8A9099]">
Plan No.:
</p>
                                <span class="text-[14px] text-[#333333]">{{ selectedPlan.plan_number || "N/A" }}</span>
                            </div>
                            <div
                                class="hidden items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]"
>
                                <p class="text-[14px] mb-0 text-[#8A9099]">
Dealer Fee:
</p>
                                <span class="text-[14px] text-[#333333]">{{
                                    $helper.formattedPercentage(selectedPlan.dealer_fee) || "N/A" }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]"
>
                                <p class="text-[14px] mb-0 text-[#8A9099]">
Min Loan Amt:
</p>
                                <span class="text-[14px] text-[#333333]">${{
                                    $helper.getFormattedAmount_(selectedPlan.min) }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]"
>
                                <p class="text-[14px] mb-0 text-[#8A9099]">
Max Loan Amt:
</p>
                                <span class="text-[14px] text-[#333333]">${{
                                    $helper.getFormattedAmount_(selectedPlan.max) }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]"
>
                                <p class="text-[14px] mb-0 text-[#8A9099]">
Interest Rate:
</p>
                                <span class="text-[14px] text-[#333333]">{{
                                    $helper.formattedPercentage(selectedPlan.interest_rate) || "N/A" }}</span>
                            </div>
                            <div
                                class="mobile:flex laptop:block items-center justify-between py-2 laptop:py-0 border-b laptop:border-b-0 border-[#EFEFEF]"
>
                                <p class="text-[14px] mb-0 text-[#8A9099]">
Payment Factor:
</p>
                                <span class="text-[14px] text-[#333333]">{{
                                    $helper.formattedPercentage(selectedPlan.payment_factor) || "N/A" }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="rounded-[10px] pb-[30px] p-[10px] shadow-[0_0_5px_3px_#cccccc6b] relative mt-[30px]"
>
                        <div>
                            <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="financialInstitution">
                                Dealer Fee</label>
                            <div class="w-full h-[40px] relative">
                                <span
                                    class="absolute left-0 top-0 z-10 w-[40px] h-full rounded-l-[8px] flex justify-center items-center font-medium text-[15px] bg-[#7695FF] text-white"
>
                                    %
                                </span>
                                <inputComponent
ref="dealerPlanFee" v-model="dealerPlanFee" name="dealerPlanFee" :required="!$helper.isEmpty(dealerPlanFee)" placeholder="0"
                                    length="6" type="text"
                                    inputmode="decimal"
                                    :regex="/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/" error-message="Invalid Dealer Fee"
                                    custom-class="!rounded-[8px] !text-[14px] border border-[#E2E5EC] outline-none !pl-[50px] !py-[7px] pr-2.5 w-full rounded-lg placeholder:text-[#AAAAAA] text-[#333333]"
/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <financingModal ref="financingModal" @selected="onPlanSelected" />

            <div v-if="!selectedFinancialInstitutions?.is_payment_link" class="w-full pt-2">
                <label for="consumersignature" class="text-[13px] font-roboto text-[#666666] mb-[6px]">Description</label>
                <textarea
id="consumersignature" v-model="description" rows="5" placeholder="Enter your description here"
                    maxlength="255"
                    class="!text-[14px] border border-[#E2E5EC] outline-none py-2 px-[12px] w-full !rounded-[8px] placeholder:text-[#AAAAAA] text-[#333333] resize-none"
/>
            </div>
        </div>
    </div>
</template>
<script>
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import customDropdown from '../partialComponent/customDropdown.vue';
import financingModal from './financingModal.vue';
import { useToast } from "vue-toastification";
const toast = useToast();
export default {

    components: {
        inputComponent,
        customDropdown,
        financingModal
    },

    props: ['invoiceDetail', 'financialInstitutes', 'callback', 'linkGenerated', 'stripURL'],
    data() {
        return {
            institute_name: '',
            description: '',
            dealerFee: '',
            dealerPlanFee: '',
            selectedFinancialInstitutions: null,
            selectedPlan: null
        }
    },
    computed: {
        validationCheck() {
            const regex = /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/
            if (!this.selectedFinancialInstitutions) return false
            if (this.selectedFinancialInstitutions?.is_payment_link) {
                return true
            } else if (this.selectedFinancialInstitutions?.is_other) {
                if (this.$helper.isEmpty(this.institute_name) || !regex.test(this.$helper.isEmpty(this.dealerFee) ? 0 : this.dealerFee)) return false;
                else return true
            } else if (this.selectedFinancialInstitutions?.is_plan_selectable) {
                if (this.$helper.isEmpty(this.selectedFinancialInstitutions) || this.$helper.isEmpty(this.selectedPlan) || !regex.test(this.$helper.isEmpty(this.dealerPlanFee) ? 0 : this.dealerPlanFee)) return false;
                else return true
            } else {
                return true;
            }
        },
    },
    watch: {
        validationCheck: {
            handler(value) {
                this.$emit("validation-change", this.validationCheck)
            },
            immediate: true,
        },

        financialInstitutes: {
            handler(value) {
                if (this.financialInstitutes?.length == 1) {
                    this.selectedFinancialInstitutions = this.financialInstitutes[0]
                    if (this.callback) {
                        this.callback('onTypeSelected', this.selectedFinancialInstitutions)
                    }
                }
            },
            immediate: true,
        }
    },
    methods: {

        onTypeSelect() {
            if (this.callback) {
                this.callback('onTypeSelected', this.selectedFinancialInstitutions)
            }
            if (this.selectedFinancialInstitutions.is_title_prefilled == '1') {
                this.institute_name = "GoodLeap"
            } else {
                this.institute_name = ""
            }
            this.selectedPlan = null
        },
        checkValidation() {
            let isValid = true;
            const refsToValidate = [
                this.$refs.instituteName,
            ];
            let firstInvalidRef = null;
            for (const ref of refsToValidate) {
                if (ref?.validate?.()) {
                    if (!firstInvalidRef) firstInvalidRef = ref;
                }
            }
            if (firstInvalidRef) {
                isValid = false;
            }
            return isValid;
        },

        async getData() {
            if (this.selectedFinancialInstitutions?.is_payment_link) {
                return {
                    institute_name: this.selectedFinancialInstitutions.title,
                    type: 'PaymentLink',
                    institute_id: this.selectedFinancialInstitutions.id
                }
            } else if (this.selectedFinancialInstitutions?.is_other) {
                return {
                    institute_id: this.selectedFinancialInstitutions.id,
                    institute_name: this.institute_name,
                    dealer_fee: this.$helper.isEmpty(this.dealerFee) ? '0' : this.dealerFee,
                    description: this.description
                }
            } else if (this.selectedFinancialInstitutions?.is_plan_selectable) {
                return {
                    institute_id: this.selectedFinancialInstitutions.id,
                    institute_name: this.selectedFinancialInstitutions.title,
                    plan_id: this.selectedPlan.id,
                    dealer_fee: this.$helper.isEmpty(this.dealerPlanFee) ? '0' : this.dealerPlanFee,
                    description: this.description
                }
            } else {
                return {
                    institute_id: this.selectedFinancialInstitutions.id,
                    institute_name: this.selectedFinancialInstitutions.title
                }
            }
        },

        copysharelink() {
            navigator.clipboard.writeText(this.stripURL)
            toast.success("URL copied successfully!");
        },

        onPlanSelected(plan) {
            this.selectedPlan = plan
        },

        selectPlanClicked() {
            this.$refs.financingModal.show(this.selectedFinancialInstitutions.id)
        },

        generateLinkClicked() {
            if (this.callback) {
                this.callback('onGenerateLinkClicked', this.selectedFinancialInstitutions)
            }
        }
    }
}
</script>